import { object, Schema, string as stringType } from 'yup';
import { ValueRanges } from 'rlv-common';

export function createNeedPageSchema(valueRanges: ValueRanges): Schema<any> {
  return object().shape({
    need: stringType().nullable(true).required('Bitte wählen Sie erst einen Tarif aus'),
  });
}
